import React, { useEffect, useState, useRef, useContext, useCallback } from "react"
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs"
import SvgHome from "@Components/CustomIcon/SvgHome"
import { baseColors, dimensions } from "@Constants/baseStyles"
import SvgDiagnostic from "@Components/CustomIcon/SvgDiagnostic"
import SvgSuivi from "@Components/CustomIcon/SvgSuivi"
import SvgBook from "@Components/CustomIcon/SvgBook"
import styles from "./styles"
import { DiagnosticStack } from "@Navigation/DiagnosticStack/DiagnosticStack"
import HomeStack from "@Navigation/HomeStack/HomeStack"
import { FollowUpStack } from "@Navigation/FollowUp/FollowUpStack"
import KnowledgeStack from "@Navigation/KnowledgeStack/KnowledgeStack"
import { useRecoilState, useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import * as Notifications from "expo-notifications"
import { notificationTokenAtom } from "@Recoil/Atom/notificationTokenAtom"
import { NotificationService } from "@Services/Notifications.Service"
import { ReminderService } from "@Services/Reminder.Service"
import { remindersListAtom } from "@Recoil/Atom/reminderAtom"
import { currentDiagnosisAtom, diagnosisShouldUpdateAtom } from "@Recoil/Atom/DiagnosisAtom"
import { CustomTabBar } from "./CustomTabBar"
import { DiagnosisState } from "@Constants/constant"
import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import { fetchNotificationStatus, fetchUserData, fetchUserDEList } from "./Logic"
import { Alert, Keyboard } from "react-native"
import { useUserPrograms } from "../../Hooks/useUserPrograms"
import { useIsFocused, getFocusedRouteNameFromRoute, useRoute } from "@react-navigation/native"
import { UserService } from "@Services/User.service"

export const hideOnScreens = ["AppointmentVisioContent"]

const Tab = createBottomTabNavigator()

Notifications.setNotificationHandler({
    handleNotification: async () => ({
        shouldShowAlert: true,
        shouldPlaySound: true,
        shouldSetBadge: false
    })
})

Notifications.addNotificationReceivedListener((notification) => {
    // console.warn(notification)
})

NotificationService.enableNotificationListenner()
const BottomTabBarStack = ({ navigation }) => {
    // const route = useRoute()
    const [user, setUser] = useRecoilState(userAtom)
    const [remindersList, setRemindersList] = useRecoilState(remindersListAtom)
    const [pushToken, setPushToken] = useRecoilState(notificationTokenAtom)
    const { fetchingDiagEduc, setEducationalDiagnosisList } = useContext(DiagnosticEducatifContext)
    const [notification, setNotification] = useState(false)
    const notificationListener = useRef()
    const responseListener = useRef()
    const [diagnosisShouldUpdate, setDiagnosisShouldUpdate] = useRecoilState(diagnosisShouldUpdateAtom)
    const denyDEAndFollowUp = fetchingDiagEduc
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)
    const { disableMenu, hasProgramInProgress, fetchPreselctedPatientProgram } = useUserPrograms()
    const isFocused = useIsFocused()
    const redirectionFromPushNotification = Notifications.useLastNotificationResponse()

    useEffect(() => {
        if (redirectionFromPushNotification) {
            navigation.navigate("FollowUpStack", { screen: "AppointmentHome" })
        }
    }, [redirectionFromPushNotification, isFocused])

    ///Need to enable notification after checking notification on backend
    useEffect(() => {
        NotificationService.registerForPushNotificationsAsync().then((localToken) => {
            setPushToken(localToken)
        })
        NotificationService.defineNotificationBackgroundTask()
        addNotificationListener()
        return () => {
            //removeNotificationListener()
        }
    }, [])

    useEffect(() => {
        if (notification) {
            const pushEventType = notification?.request?.content?.data?.type
            if (pushEventType === "DE_STATE_UPDATE") {
                setDiagnosisShouldUpdate(!diagnosisShouldUpdate)
            }
        }
    }, [notification])

    const removeNotificationListener = () => {
        Notifications.removeNotificationSubscription(notificationListener.current)
        Notifications.removeNotificationSubscription(responseListener.current)
        Notifications.setNotificationHandler({
            handleNotification: async () => ({
                shouldShowAlert: false,
                shouldPlaySound: false,
                shouldSetBadge: false
            })
        })
    }

    const addNotificationListener = () => {
        notificationListener.current = Notifications.addNotificationReceivedListener((notification) => {
            setNotification(notification)
        })

        responseListener.current = Notifications.addNotificationResponseReceivedListener((response) => {})
        Notifications.setNotificationHandler({
            handleNotification: async () => ({
                shouldShowAlert: true,
                shouldPlaySound: true,
                shouldSetBadge: false
            })
        })
    }
    Notifications.addNotificationResponseReceivedListener((response) => {
        setNotification(response)
    })

    useEffect(() => {
        if (!pushToken) {
            removeNotificationListener()
        } else {
            addNotificationListener()
        }
    }, [pushToken])

    const getReminders = async () => {
        const response = await ReminderService.getList()
        const reminders = response?.data?.data
        if (reminders) {
            setRemindersList(reminders)
        }
    }

    const scheduleNotifications = async () => {
        let notificationList = []
        remindersList?.map((reminder) => {
            const reminderNotificationDates = reminder.reminderNotifications
            reminderNotificationDates?.map((reminderNotif) => {
                let notif = {
                    date: reminderNotif?.realNotificationDate,
                    title: reminder?.type?.name,
                    body: reminder.name
                }
                notificationList.push(notif)
            })
        })
        LocalStorage.getReminderNotification(notificationList).then(async (oldReminders) => {
            if (JSON.stringify(oldReminders) !== JSON.stringify(remindersList)) {
                const cancelAll = await NotificationService.cancelNotificationSchedule()
                notificationList.map((notif) => {
                    NotificationService.schedulePushNotificationForDate(notif.date, notif.title, notif.body)
                })
                LocalStorage.saveReminderNotification(notificationList)
            }
        })
    }

    useEffect(() => {
        if (remindersList?.length > 0) {
            scheduleNotifications()
        }
    }, [remindersList])

    useEffect(() => {
        fetchUserData({ setUser, navigation })
    }, [])

    const handleDENavigation = (e, navigationCallBack) => {
        if (denyDEAndFollowUp || fetchingDiagEduc) {
            e.preventDefault()
        } else {
            navigationCallBack?.()
        }
    }

    useEffect(() => {
        const abortController = new AbortController()
        if (user) {
            getReminders()
            fetchNotificationStatus({ pushToken, setPushToken })
        }

        return () => {
            abortController.abort()
        }
    }, [user])

    const tabBarTint = {
        tabBarActiveTintColor: denyDEAndFollowUp ? baseColors.grey : baseColors.orange.primary,
        tabBarInactiveTintColor: denyDEAndFollowUp ? baseColors.grey : baseColors.green.primary
    }

    const PatienthasProgramInProgress = !hasProgramInProgress && currentEducationalDiagnosis === null

    const disableDiagnosisMenu =
        currentEducationalDiagnosis?.diagnosisStatus?.code === DiagnosisState.IN_PREPARATION ||
        fetchingDiagEduc ||
        PatienthasProgramInProgress

    const diagnosticTintColor = {
        tabBarActiveTintColor: disableDiagnosisMenu ? baseColors.grey : baseColors.orange.primary,
        tabBarInactiveTintColor: disableDiagnosisMenu ? baseColors.grey : baseColors.green.primary
    }

    const [isKeyboardVisible, setKeyboardVisible] = useState(false)

    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener("keyboardDidShow", () => {
            setKeyboardVisible(true)
        })
        const keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", () => {
            setKeyboardVisible(false)
        })

        return () => {
            keyboardDidHideListener.remove()
            keyboardDidShowListener.remove()
        }
    }, [])

    useEffect(() => {
        fetchUserDEList(user?.id, setEducationalDiagnosisList)
        fetchPreselctedPatientProgram()
    }, [isFocused])

    const handlePostNotificationFCM = () => {
        NotificationService.registerForPushNotificationsAsync()
            .then((token) => {
                UserService.subscribeNotification(token)
                    .then((response) => {
                        setPushToken(token)
                        // ShowToast({ type: "success", message: "Système de notification activé avec succès" })
                        LocalStorage.saveNotificationStatus(true)
                    })
                    .catch((e) => {
                        // setErrorMessage(JSON.stringify(e))
                        // ShowToast({ type: "error", message: "Failed to get push token" })
                        // setErrorModalVisible(true)
                        // setRegistring(false)
                    })
                setPushToken(token)
                // setRegistring(false)
            })
            .catch((e) => {
                console.log({ failedToSendFcm: e })
                // setErrorMessage(JSON.stringify(e))
                // ShowToast({ type: "error", message: "Failed to get push token" })
                // setErrorModalVisible(true)
                // setRegistring(false)
            })
    }

    useEffect(() => {
        handlePostNotificationFCM()
    }, [])

    const programTintColor = {
        tabBarActiveTintColor: disableMenu ? baseColors.grey : baseColors.orange.primary,
        tabBarInactiveTintColor: disableMenu ? baseColors.grey : baseColors.green.primary
    }

    const getTabBarVisibility = useCallback((route) => {
        const routeName = getFocusedRouteNameFromRoute(route)
        return routeName ? hideOnScreens.indexOf(routeName) === -1 : true
    }, [])

    const isIpad = dimensions.fullWidth > 640

    return (
        <Tab.Navigator
            tabBar={(props) => <CustomTabBar {...props} />}
            screenOptions={({ route }) => ({
                headerShown: false,
                tabBarStyle: styles.bottomTabBar,
                tabBarVisible: getTabBarVisibility(route) && !isKeyboardVisible
            })}
            initialRouteName="Home"
        >
            <Tab.Screen
                options={({ route }) => ({
                    tabBarLabel: isIpad ? "" : "Accueil",
                    ...tabBarTint,
                    tabBarLabelStyle: styles.label,
                    tabBarIcon: ({ focused, color }) => (
                        <SvgHome width={isIpad ? 64 : 23} color={color} height={isIpad ? 64 : 23} />
                    )
                })}
                listeners={{
                    tabPress: (e) => handleDENavigation(e, () => navigation.navigate("Home"))
                }}
                name="Home"
                component={HomeStack}
            />
            <Tab.Screen
                options={({ route }) => ({
                    tabBarLabel: isIpad ? "" : "Diagnostic",
                    ...diagnosticTintColor,
                    tabBarLabelStyle: {
                        ...styles.label
                    },
                    tabBarIcon: ({ color }) => (
                        <SvgDiagnostic color={color} width={isIpad ? 64 : 23} height={isIpad ? 64 : 23} />
                    )
                })}
                name="DiagnosticStack"
                component={DiagnosticStack}
                listeners={{
                    tabPress: (e) =>
                        disableDiagnosisMenu
                            ? e.preventDefault()
                            : handleDENavigation(e, () => navigation.navigate("DiagnosticStack"))
                }}
            />
            <Tab.Screen
                options={({ route }) => ({
                    tabBarLabel: isIpad ? "" : "Mon suivi",
                    ...programTintColor,
                    tabBarLabelStyle: {
                        ...styles.label
                    },
                    tabBarIcon: ({ focused, color }) => (
                        <SvgSuivi color={color} width={isIpad ? 64 : 23} height={isIpad ? 64 : 23} />
                    )
                })}
                name="FollowUpStack"
                component={FollowUpStack}
                listeners={{
                    tabPress: (e) =>
                        disableMenu
                            ? e.preventDefault()
                            : handleDENavigation(e, () => navigation.navigate("FollowUpStack"))
                }}
            />
            <Tab.Screen
                options={({ route }) => ({
                    tabBarLabel: isIpad ? "" : "Savoir",
                    ...tabBarTint,
                    ...programTintColor,
                    tabBarLabelStyle: styles.label,
                    tabBarIcon: ({ focused, color }) => (
                        <SvgBook width={isIpad ? 64 : 23} color={color} height={isIpad ? 64 : 23} />
                    )
                })}
                name="Knowledge"
                component={KnowledgeStack}
                listeners={{
                    tabPress: (e) =>
                        disableMenu ? e.preventDefault() : handleDENavigation(e, () => navigation.navigate("Knowledge"))
                }}
            />
        </Tab.Navigator>
    )
}

export default BottomTabBarStack
